import { render, staticRenderFns } from "./BlockViewButton.vue?vue&type=template&id=ff74ebd0"
import script from "./BlockViewButton.vue?vue&type=script&lang=js"
export * from "./BlockViewButton.vue?vue&type=script&lang=js"
import style0 from "./BlockViewButton.vue?vue&type=style&index=0&id=ff74ebd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports